import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-device-login-warning-modal',
    templateUrl: './device-login-warning-modal.component.html',
    styleUrls: ['./device-login-warning-modal.component.scss']
})
export class DeviceLoginWarningModalComponent {

    constructor(
        private readonly dialogRef: MatDialogRef<DeviceLoginWarningModalComponent>,
        private readonly dialog: MatDialog,
        private readonly router: Router
    ) { }

    public cancel(): void {
        this.dialogRef.close()
    }

    public goToDevicesManagement(): void {
        // Closes the current modal
        this.dialogRef.close();
        // Closes all open modals
        this.dialog.closeAll();
        this.router.navigate(['/devices-management']);
    }
}
